import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import PagamentoRealizado from "../../../assets/kinologyIcons/svg/pagamento_realizado.svg";
import { FaturaProps } from "../../../interfaces/cartao.interface";
import { Colors } from "../../../styles/colors";
import { FinancialActions } from "../../../store/ducks/financial";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalPagamentoRealizado: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);
	const faturas: FaturaProps[] = useSelector((state: any) => state.financial.faturas);

	const modal_visible = useSelector((state: any) => state.financial.modal_pagamento_realizado);

	const ModalClose = () => {
		console.log("asdasd");
	};

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_pagamento_realizado(false))
	};

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modal_visible}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={modal_visible}>
				<ModalContainer>
					<ModalContent>
						<IconContainer>
							<img
								style={{ width: "4rem", height: "4rem" }}
								src={PagamentoRealizado}
							/>
						</IconContainer>
						<Title>{current_language?.pagamento_realizado}</Title>
						{
							faturas?.filter((item)=> item?.FATURA_TIPO == 'PENDING')?.length >= 1
							? 
								<>
									<InfoText>{current_language?.faturas_pendentes}</InfoText>
									<InfoText>{current_language?.pagamento_faturas_}</InfoText>
								</>
							:	<InfoText>
								{current_language?.debito_quitado_acesso_liberado}
								</InfoText>
						}
						
						<Button onClick={handleClose}>{current_language?.entendi}</Button>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const IconContainer = styled.div`
	margin-bottom: 16px;
	margin-top: 16px;
`;

const Title = styled.h2`
	font-size: 18px;
	color: #002060;
	margin: 0 0 8px;
`;

interface ButtonProps {
	primary?: boolean;
}

const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	font-size: 16px;
	font-weight: bold;
	color: white;
	background-color: ${({ primary }) => (primary ? "white" : "#009973")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #009973")};
	color: ${({ primary }) => (primary ? "#009973" : "white")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ primary }) => (primary ? "#009973" : "#f6f6f6")};
		color: ${({ primary }) => (primary ? "#009973" : "#009973")};
	}
`;

const InfoText = styled.p`
	font-size: 14px;
	color: ${Colors.primary_blue_k_main};
	margin: 0 0 16px;
`;

export default ModalPagamentoRealizado;
